import { defineMessages } from 'react-intl';
import { get, find, isEmpty } from 'lodash';

const intlPriceOptionLabel = defineMessages({
  perItem: {
    id: 'web_2.price_option_label.per_item',
    defaultMessage: '/item'
  },
  perPerson: {
    id: 'web_2.price_option_label.per_person',
    defaultMessage: '/person'
  },
  perHour: {
    id: 'web_2.price_option_label.per_hour',
    defaultMessage: '/hour'
  },
  flatFee: {
    id: 'web_2.price_option_label.flat_fee',
    defaultMessage: ' flat fee'
  }
});

const intlCollectVatCopy = defineMessages({
  vatCopy: {
    id: 'inbox.create_add_on_modal.collect_vat_copy',
    defaultMessage: 'If you collect VAT, please include it in the price above.'
  },
  gstCopy: {
    id: 'inbox.create_add_on_modal.collect_gst_copy',
    defaultMessage: 'If you collect GST, please include it in the price above.'
  },
  hstCopy: {
    id: 'inbox.create_add_on_modal.collect_hst_copy',
    defaultMessage: 'If you collect HST, please include it in the price above.'
  },
  salesTaxCopy: {
    id: 'inbox.create_add_on_modal.collect_sales_tax_copy',
    defaultMessage: 'If you collect sales tax, please include it in the price above.'
  }
});

const intlAddOnTaxTypeOptions = defineMessages({
  vat: {
    id: 'inbox.create_calculator.tax_option_vat',
    defaultMessage: 'VAT'
  },
  gst: {
    id: 'inbox.create_calculator.tax_option_gst',
    defaultMessage: 'GST'
  },
  hst: {
    id: 'inbox.create_calculator.tax_option_hst',
    defaultMessage: 'HST'
  },
  pst: {
    id: 'inbox.create_calculator.tax_option_pst',
    defaultMessage: 'PST'
  },
  qst: {
    id: 'inbox.create_calculator.tax_option_qst',
    defaultMessage: 'QST'
  },
  rst: {
    id: 'inbox.create_calculator.tax_option_rst',
    defaultMessage: 'RST'
  },
  salesTax: {
    id: 'inbox.create_calculator.tax_option_sales_tax',
    defaultMessage: 'Sales Tax'
  },
  PS_PROCESSING: {
    id: 'inbox.create_calculator.tax_option_ps_processing',
    defaultMessage: 'Processing'
  },
  other: {
    id: 'inbox.create_calculator.tax_option_other',
    defaultMessage: 'Other'
  }
});

export const priceOptionLabel = {
  per_item: intlPriceOptionLabel.perItem,
  per_person: intlPriceOptionLabel.perPerson,
  per_hour: intlPriceOptionLabel.perHour,
  flat_fee: intlPriceOptionLabel.flatFee
};

export const collectVatCopy = {
  VAT: intlCollectVatCopy.vatCopy,
  GST: intlCollectVatCopy.gstCopy,
  HST: intlCollectVatCopy.hstCopy,
  other: intlCollectVatCopy.salesTaxCopy
};

export const addOnTaxTypeOptions = {
  VAT: intlAddOnTaxTypeOptions.vat,
  GST: intlAddOnTaxTypeOptions.gst,
  HST: intlAddOnTaxTypeOptions.hst,
  PST: intlAddOnTaxTypeOptions.pst,
  QST: intlAddOnTaxTypeOptions.qst,
  RST: intlAddOnTaxTypeOptions.rst,
  sales_tax: intlAddOnTaxTypeOptions.salesTax,
  PS_PROCESSING: intlAddOnTaxTypeOptions.PS_PROCESSING,
  other: intlAddOnTaxTypeOptions.other
}

export const priceDisplayString = (currencySymbol, price, priceOptions) => {
  return `${currencySymbol}${Number(price || 0).toFixed(2)}${priceOptionLabel[priceOptions] || ''}`;
};

export const getCurrentSpaceRentalContract = (contract) => {
  // current contracts come from contracts array on confirmed -> offer and pending array on a request -> offer
  const activeContracts = get(contract, 'data.contracts');
  const currentContracts = !isEmpty(activeContracts)
    ? activeContracts
    : get(contract, 'data.pending', []);
  return find(currentContracts, { type: 'SPACE_RENTAL' }) || {};
}